import { supabase } from '../lib/supabase'
import { useAuthStore } from '../stores/authStore'

export interface LogAuditInput {
  action: string
  entity_type: string
  entity_id?: string | null
  changes?: Record<string, unknown> | null
}

/**
 * Écrit une entrée dans audit_logs. Best-effort : log en console si l'INSERT
 * échoue (RLS ou réseau) — l'opération métier appelante ne doit jamais être
 * bloquée par un échec de log.
 */
export const logAudit = async (input: LogAuditInput): Promise<void> => {
  const profile = useAuthStore.getState().profile
  if (!profile?.pharmacy_id) return

  const payload = {
    pharmacy_id: profile.pharmacy_id,
    actor_id: profile.id,
    actor_role: profile.role,
    action: input.action,
    entity_type: input.entity_type,
    entity_id: input.entity_id ?? null,
    changes: input.changes ?? null,
  }

  const { error } = await supabase.from('audit_logs').insert(payload as never)
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('audit_logs insert failed:', error.message, payload)
  }
}
